import React from 'react'
import { useNavigate } from 'react-router-dom'
import './GoBackButton.css'

interface GoBackButtonProps {
  previousPageState: any
  onBackClick?: () => void
}

const GoBackButton: React.FC<GoBackButtonProps> = ({
  previousPageState,
  onBackClick,
}) => {
  const navigate = useNavigate()

  const backLabel =
    typeof previousPageState?.backLabel === 'string' &&
    previousPageState.backLabel.trim()
      ? previousPageState.backLabel
      : 'Back to appointment'

  const fixMccContentRowPadding = (): void => {
    const messageContainerPage = document.querySelector(
      '.message-container-page',
    )
    if (messageContainerPage) {
      setTimeout(() => {
        const mccContentRow = document.querySelector('.mcc-content.row')
        if (mccContentRow) {
          ;(mccContentRow as HTMLElement).style.padding = `0px 12px`
        }
      }, 1000)
    }
  }

  fixMccContentRowPadding()

  return (
    <div className="go-back-button-container">
      <button
        type="button"
        className="unstyled-button link-text"
        onClick={() => {
          if (onBackClick) {
            onBackClick()
            return
          }
          navigate(previousPageState.path, {
            state: {
              ...previousPageState,
            },
          })
        }}
      >
        <span className="mgc_left_line"></span>
        <span className="text">{backLabel}</span>
      </button>
    </div>
  )
}

export default GoBackButton
